import { object, optional, string, array, enums } from 'superstruct';

export const booleanEnum = ['true', 'false'];

export const modelConfigSchemaObj = object({
  name: optional(string()),
  carlineId: optional(string()),
  slug: optional(string()),
  useCarConfigurationService: optional(enums(booleanEnum)),
});
export const fiveStarsConfigSchemaObj = object({
  mlpDisclaimer: optional(string()),
  viewAllDisclaimer: optional(string()),
});
export const imageModelMapSchemaObj = object({
  name: optional(string()),
  slug: optional(string()),
  modelYear: optional(string()),
  background: optional(string()),
  carImage: optional(string()),
  carImageAlt: optional(string()),
  requestName: optional(string()),
  isNewImage: optional(enums(booleanEnum)),
});
export const schemaObject = {
  modelConfiguration: optional(array(modelConfigSchemaObj)),
  fiveStarsConfig: optional(array(fiveStarsConfigSchemaObj)),
  imageModelMap: optional(array(imageModelMapSchemaObj)),
};

export const FiveStarsSchema = object(schemaObject);
